// ----------------------------------------------------------------------
// <copyright file="Izenda.SliderBox.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  const { isNil, assign } = require('lodash/fp');

  // Fix issues IE9, matchMedia not present
  if (typeof window !== 'undefined') {
    var matchMediaPolyfill = function matchMediaPolyfill() {
      return {
        matches: false,
        addListener: function() {},
        removeListener: function() {}
      };
    };
    window.matchMedia = window.matchMedia || matchMediaPolyfill;
  }
  require('slick-carousel');

  var React = require('react');
  var observer = require('mobx-react').observer;
  var localizer = require('share/localization/Izenda.Localizer');
  var classnames = require('classnames');
  var Slider = require('react-slick');

  const onClick = props => () => {
    const onPreArrowClick = props.onPreArrowClick || (() => Promise.resolve(true));
    return onPreArrowClick(true).then(() => props.onClick());
  };

  var PrevArrow = React.createClass({
    render: function() {
      var prevButtonStyle = {
        zIndex: 1,
        left: this.props.centerPadding / 2 + 'px'
      };

      return (
        <button
          {...this.props}
          title={localizer.getText('DASHBOARD_TOOLTIP_PREVIOUS_TILE')}
          className="slick-arrow slick-prev"
          style={prevButtonStyle}
          onClick={onClick(this.props)}
        />
      );
    }
  });

  var NextArrow = React.createClass({
    render: function() {
      var nextButtonStyle = {
        right: this.props.centerPadding / 2 + 'px'
      };

      return (
        <button
          {...this.props}
          title={localizer.getText('DASHBOARD_TOOLTIP_NEXT_TILE')}
          className="slick-arrow slick-next"
          style={nextButtonStyle}
          onClick={onClick(this.props)}
        />
      );
    }
  });

  var SliderBox = React.createClass({
    propTypes: {
      settings: React.PropTypes.object
    },

    /**
     * Init slider
     */
    initSlider: function() {
      var settings = this.props.settings;

      if (isNil(settings)) {
        return;
      }

      var newSettings = assign(
        {
          prevArrow: <PrevArrow {...settings} />,
          nextArrow: <NextArrow {...settings} />
        },
        settings
      );

      newSettings.centerPadding = newSettings.centerPadding + 'px';

      return newSettings;
    },

    render: function() {
      var sliderContainerClass = classnames('u_fullHeight izenda-SliderContainer', this.props.className);
      var settings = this.initSlider();

      return (
        <div className={sliderContainerClass}>
          <Slider {...settings}>{this.props.children}</Slider>
        </div>
      );
    }
  });

  module.exports = observer(SliderBox);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.SliderBox.jsx